module.exports = __webpack_public_path__ + "img/hortiImage.4edacc7d.svg";